import { Navigate, useParams } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';
import { canCreateAdminNote } from '../../lib/chart/chartDocumentAccess';

/** Protected deep link for creating an admin note on a client chart. */
export function ChartAdminNoteRoute(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const { role } = usePermissions();

  if (!id) {
    return <Navigate to="/dashboard/caseload" replace />;
  }

  if (!canCreateAdminNote(role)) {
    return <Navigate to={`/dashboard/clients/${id}?tab=chart`} replace />;
  }

  return <Navigate to={`/dashboard/clients/${id}?tab=chart&newAdminNote=1`} replace />;
}
